export const MAIN_DRIVER_LEGAL_ID_SAVE = 'MAIN_DRIVER_LEGAL_ID_SAVE';
